module.exports = __webpack_public_path__ + "static/media/202409xixun.40481bd0.jpg";